// Utilitário para checagem de versão do app
export async function checkAppVersion() {
  if (typeof window === 'undefined' || typeof window.fetch !== 'function') {
    return;
  }
  try {
    const r = await fetch('/version.json', { cache: 'no-store' });
    if (!r.ok) throw new Error('Failed to fetch /version.json');
    const data = await r.json();
    const remote = data.version;
    const local = localStorage.getItem('app_version');
    if (local && local !== remote) {
      localStorage.clear();
      sessionStorage.clear();
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map(k => caches.delete(k)));
      }
      if (navigator.serviceWorker) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map(r => r.unregister()));
      }
      localStorage.setItem('app_version', remote);
      window.location.reload();
    } else if (!local) {
      localStorage.setItem('app_version', remote);
    }
  } catch (e) {
    console.error("Error checking app version:", e);
  }
}
